import { breakingStory, heroSideItems, navCategories } from "@/mocks/homeNews";

interface HeroProps {
  onCat: (cat: string) => void;
}

export default function Hero({ onCat }: HeroProps) {
  return (
    <section className="relative overflow-hidden">
      <div className="mx-auto w-full max-w-7xl px-4 pt-6 md:px-6 md:pt-8" id="top">
        {/* eyebrow / ticker */}
        <div className="flex items-center gap-3 overflow-hidden rounded-2xl bg-background-950 px-4 py-2.5 text-background-50">
          <span className="flex shrink-0 items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-300">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500" />
            </span>
            速报中
          </span>
          <div className="no-scrollbar flex flex-1 items-center gap-8 overflow-x-auto whitespace-nowrap text-sm text-background-200">
            {navCategories.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => onCat(c)}
                className="cursor-pointer transition hover:text-accent-300"
              >
                {c}
              </button>
            ))}
          </div>
          <a
            href="#today"
            className="hidden shrink-0 text-xs text-accent-300 underline underline-offset-4 sm:block"
          >
            一键直达 <i className="ri-corner-down-right-line" />
          </a>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-5 lg:grid-cols-12">
          {/* main breaking card */}
          <article className="group relative col-span-1 overflow-hidden rounded-3xl lg:col-span-8">
            <a href="#today" className="block">
              <div className="relative h-[300px] w-full overflow-hidden md:h-[420px]">
                <img
                  src={breakingStory.img}
                  alt={`71吃瓜今日头瓜：${breakingStory.title}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-4 md:p-6">
                  <span className="inline-flex items-center rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-background-50 dark:text-foreground-950">
                    <i className="ri-flashlight-fill mr-1" /> {breakingStory.tag}
                  </span>
                  <h1 className="mt-3 font-heading text-xl font-black leading-snug text-white md:text-3xl md:leading-snug">
                    {breakingStory.title}
                  </h1>
                  <p className="mt-2 hidden text-sm leading-relaxed text-white/85 md:block md:max-w-3xl">
                    {breakingStory.summary}
                  </p>
                  <div className="mt-3 flex items-center gap-3 text-xs text-white/75">
                    <span className="flex items-center gap-1"><i className="ri-time-line" />{breakingStory.time}</span>
                    <span className="flex items-center gap-1"><i className="ri-eye-line" />{breakingStory.views} 围观</span>
                  </div>
                </div>
              </div>
            </a>
          </article>

          {/* side list */}
          <div className="col-span-1 flex flex-col gap-4 lg:col-span-4">
            <div className="rounded-2xl border border-background-200 bg-background-50 p-1.5">
              <div className="flex items-center justify-between px-3 py-2">
                <h2 className="flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-secondary-100">
                    <i className="ri-flashlight-line text-secondary-700" />
                  </span>
                  刚刚热起来的瓜
                </h2>
              </div>
              <div className="divide-y divide-background-200/70">
                {heroSideItems.map((it, i) => (
                  <a key={it.id} href="#today" className="group flex items-start gap-3 px-3 py-3 transition hover:bg-secondary-100/60">
                    <span className="mt-0.5 font-heading text-lg font-black leading-none text-accent-500">{`0${i + 1}`}</span>
                    <span className="flex min-w-0 flex-1 flex-col gap-1">
                      <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition group-hover:text-foreground-950">
                        {it.title}
                      </span>
                      <span className="text-xs text-foreground-400">
                        <i className="ri-eye-line mr-1" />{it.views}
                        <span className="ml-2 text-primary-600">{it.tag}</span>
                      </span>
                    </span>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}